import { api } from '@creditsights/api-ui-web';
import { CalculateFundamentalsDTO, FundamentalMetricsDto } from './dtos/fundamentalMetrics.dto';
import { CalculatedFundamentals } from '../models/CalculatedFundamentals';

const riskProductsUri = '/risk-products/v1';
export const getFundamentalUrl = (companyId: string | null): string =>
  `${riskProductsUri}/company/${companyId}/fundamentals`;
export const getCalculateUrl = (): string => `${riskProductsUri}/company/calculate-fundamentals`;

export const fetchCompanyFundamentals = async (companyId: string): Promise<FundamentalMetricsDto> => {
  const resp = await api.get(getFundamentalUrl(companyId));
  return resp?.data;
};

export const calculateCompanyFundamentals = async (
  calculateFundamentalsData: CalculateFundamentalsDTO
): Promise<CalculatedFundamentals> => {
  const { data } = await api.post<CalculatedFundamentals>(getCalculateUrl(), calculateFundamentalsData);
  return data;
};
